import PageBoxGrid from './page-box-grid.js';

export default PageBoxGrid;
